export default (value: string | null) => {
  if (isNaN(Number(value))) {
    return "Value must be a number"
  }
  if (Number(value) < 0) {
    return `Value must be a more than or equal to 0.`
  }
  if (Number(value) > 1) {
    return `Value must be a less than or equal to 1.`
  }
  return true
}
